import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "bulma/css/bulma.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { Provider } from "react-redux";

import configureCustomStore from "./state/configureStore";
import {GoogleOAuthProvider} from "@react-oauth/google";
import {createRoot} from "react-dom/client";
import config from "./config.json"

const store = configureCustomStore();

const  root =  createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <GoogleOAuthProvider clientId={ config.GOOGLE_CLIENT_ID }>
          <App></App>
        </GoogleOAuthProvider>
    </Provider>
)

